/**
 * Dados institucionais usados nas páginas legais (Política de Privacidade e
 * Termos de Uso). Centralizados aqui para que uma alteração cadastral
 * precise ser feita em um único lugar.
 */
const company = {
  name: 'EasyCart Minimercados',
  cnpj: '40.919.822/0001-95',
  phone: '45 9151-6789',
  // TODO: substituir pelo e-mail oficial de atendimento/privacidade da empresa.
  email: 'contato@easycart.com.br',
  appUrl: 'https://www.onelink.to/easycart',
  lastUpdated: '15 de setembro de 2026',
};

export default company;
